export const adminStackLinking = {
    screens: {
        Admin_Home: {
            path: 'admin/home',
        },
        Admin_Notes: {
            path: 'admin/notes',
        },
        Admin_LLMChat: {
            path: 'admin/llm-chat',
        },
    },
};
export const adminTabsLinking = {
    screens: {
        Admin_Home: {
            path: 'admin/*',
        },
    },
};
